// extracted by mini-css-extract-plugin
export var copyableItem = "_o-0";
export var underlined = "_o-1";